import { render } from "./LicenseIcon.vue?vue&type=template&id=14e7a0d2"
import script from "./LicenseIcon.vue?vue&type=script&lang=js"
export * from "./LicenseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__